export default __webpack_public_path__ + "static/media/information--central-lane--g1.fe7e0080.png";